<template>
<div class="nj-box" :class="getPosition">
    <div class="nj-box-container" :style="styles">
        <div class="nj-box-top">
            <div class="nj-box-title">
                <slot name="top"></slot>
            </div>
            <div class="nj-box-close" title="Cerrar">
                <i class="mdi-close" @click="close($event)"></i>
            </div>
        </div>
        <div class="nj-box-center">
            <slot name="center"></slot>
        </div>
        <div class="nj-box-bottom">
            <Buttons>
                <slot name="bottom"></slot>
            </Buttons>
        </div>
    </div>
</div>
</template>
<script>
import { Buttons } from "."

export default {
    name: "Box",
    components: {
        Buttons
    },
    props: {
        width: {
            type: String,
            default: "",
        },
        centered: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        styles() {
            let values = ""
            if (this.width) {
                values += "max-width: " + this.width + " !important; "
            }
            return values
        },
        getPosition() {
            if (this.centered != null && this.centered) {
                return "centered"
            }
            else {
                return ""
            }
        }
    },
    methods: {
        close(event) {
            this.$emit("close")
        },
    },
}
</script>

<style scoped>
.nj-box {
    top: 0;
    left: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: start;
    background-color: #00000060;
    padding: 12px;
    overflow: auto;
    z-index: 10;
}

.nj-box.centered {
    justify-content: center;
    align-items: center;
}

.nj-box-container-2 {
    background-color: #fff;
    padding: 12px;
    border: 1px solid transparent;
    border-radius: var(--radius);
    min-width: 320px;
}

.nj-box-container {
    background-color: #fff;
    border-radius: var(--radius);
    width: 1200px;
    min-width: 320px;
    border-radius: 4px;
}

.nj-box-top {
    padding: 8px 12px;
    border-bottom: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 4px 6px -4px #00000024;
    background-color: var(--nj-color-blue);
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
}

.nj-box-title {
    font-size: 18px;
    color: #fff;
}

.nj-box-close {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px;
    color: #fff;
    border: 1px solid var(--nj-color-blue);
    border-radius: 50%;
}

.nj-box-close>i {
    cursor: inherit;
    font-size: 20px;
}

.nj-box-center {
    padding: 12px;
    background-color: #f8f8f8;
}

.nj-box-bottom {
    padding: 8px 12px;
    border-top: 1px solid #ccc;
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
}
</style>